<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          @click="addPath"
          >新增校车路线</el-button
        >
      </div>
      <div class="search_box">
        <el-input
          size="mini"
          v-model.trim="requestData.routeName"
          placeholder="路线名称"
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-steps>
                <el-step
                  v-for="(activity, index) in props.row.schoolBusSiteList"
                  :key="index"
                  :title="activity.siteName"
                  :description="
                    $Common.dateFormatDateTwo(activity.siteArrivalTime)
                  "
                >
                </el-step>
              </el-steps>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="routeName" label="路线名称" align="center">
          </el-table-column>
          <el-table-column
            prop="routeDrivingTime"
            label="站点数量"
            align="center"
            width="170"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.schoolBusSiteList.length }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="routeDrivingTime"
            label="预计时间"
            align="center"
            width="170"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.routeDrivingTime }}分钟</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="创建时间"
            width="270"
            align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="rowData">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="editRowInfo(rowData.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delRowInfo(rowData.row.routeId)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <bus-rouute-dialog
      :info="rowInfo"
      :type="dialogType"
      :showDialog="showDialog"
      @close="close"
      @saveClick="saveClick"
    ></bus-rouute-dialog>
  </div>
</template>

<script>
import BusRouuteDialog from "./components/BusRouuteDialog";
import Sortable from "sortablejs";
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    BusRouuteDialog
  },
  props: {},
  data() {
    //这里存放数据
    return {
      requestData: {
        pageNum: 1,
        pageSize: 20,
        routeName: "",
        schoolId: this.$store.state.schoolId
      },
      total: 0,
      tableData: [],
      mapCenter: {
        lng: 0,
        lat: 0
      },
      waypoints: [],
      mapStart: "",
      mapEnd: "",
      rowInfo: {},
      dialogType: "add",
      showDialog: false
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {
    // 基础信息
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  //方法集合
  methods: {
    searchData() {
      this.requestData.pageNum = 1;
      this.getSchoolBulRoute();
    },
    async getSchoolBulRoute() {
      let res = await this.$Http.getSchoolBulRoute(this.requestData);
      if (res.code == 200) {
        this.total = res.data.total || 0;
        this.tableData = res.data.list || [];
      } else if (res.code == 101) {
        this.total = 0;
        this.tableData = [];
      } else {
        this.total = 0;
        this.tableData = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    addPath() {
      this.rowInfo = {
        routeName: "",
        routeDrivingTime: "",
        schoolBusSiteList: [],
        schoolId: this.$store.state.schoolId
      };
      this.dialogType = "add";
      this.showDialog = true;
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getSchoolBulRoute();
    },
    mapClick(val) {
      this.$confirm("是否添加当前位置为途径点?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "添加成功!"
          });
          this.waypoints.push(val.point);
          if (this.waypoints.length == 1) {
            this.mapStart = this.waypoints[0];
          } else {
            this.mapEnd = this.waypoints[this.waypoints.length - 1];
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消添加"
          });
        });
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getSchoolBulRoute();
    },
    editRowInfo(info) {
      let obj = Object.assign({}, info);
      obj.schoolBusSiteList = obj.schoolBusSiteList.map((item, index) => {
        item.siteArrivalTime = item.siteArrivalTime * 1000;
        return item;
      });
      this.rowInfo = obj;
      this.dialogType = "edit";
      this.showDialog = true;
    },
    async delRowInfo(id) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await this.$Http.delSchoolBulRoute({ routeId: id });
          if (res.code == 200) {
            this.getSchoolBulRoute();
          } else if (res.code == 101) {
          } else {
            this.$message({
              message: res.messsage,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
        }
      });
    },
    close() {
      this.showDialog = false;
    },
    saveClick(info) {
      let obj = Object.assign({}, info);
      obj.schoolBusSiteList = obj.schoolBusSiteList.map((item, index) => {
        item.siteArrivalTime = item.siteArrivalTime / 1000;
        return item;
      });
      this.addOrEditSchoolBulRoute(obj);
    },
    async addOrEditSchoolBulRoute(info) {
      var res;
      if (this.dialogType == "add") {
        res = await this.$Http.addSchoolBulRoute(info);
      } else {
        res = await this.$Http.editSchoolBulRoute(info);
      }
      if (res.code == 200) {
        this.showDialog = false;
        this.getSchoolBulRoute();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getSchoolBulRoute();
    //使每次都可以拖拽
    // this.$nextTick(()=>{
    //   setTimeout(()=>{
    //     this.rowDrop();
    //   },100)
    // })
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.map_box {
  width: 80%;
  margin: 0px 10%;
  height: 100%;
}
.map {
  width: 100%;
  height: 100%;
}
.mapView {
  width: 100%;
  height: 100%;
  flex: 1;
}
</style>
